<template>
  <div>
    <Cards />
  </div>
</template>

<script>
import Cards from "@/components/Ondemand/Payments/Cards.vue";

export default {
  components: { Cards },
};
</script>

<style lang="scss" scoped></style>
